import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { PasswordInput } from "../components/PasswordInput";
import { toast } from "sonner";
import logoNavy from "../assets/logo-navy.png";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ref = searchParams.get("ref") || "";
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await register({ ...form, referral_code: ref || undefined }); toast.success("Account created!"); navigate("/account"); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md bg-white rounded-2xl border border-black/5 p-8 shadow-sm">
        <div className="text-center mb-6">
          <img src={logoNavy} alt="Begum's Biryani Secret" className="mx-auto h-16 w-auto mb-3" />
          <h1 className="font-serif text-3xl text-navy">Create Account</h1>
          <p className="text-sm text-muted-foreground mt-1">Join the royal table</p>
          {ref && <div className="mt-2 text-xs bg-gold/10 text-navy rounded-full px-3 py-1.5 inline-block" data-testid="referral-applied">Referred by a friend — a welcome coupon awaits you!</div>}
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="text-xs font-medium text-muted-foreground">Full Name</label><input value={form.name} onChange={set("name")} required data-testid="register-name" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>
          <div><label className="text-xs font-medium text-muted-foreground">Email</label><input type="email" value={form.email} onChange={set("email")} required data-testid="register-email" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>
          <div><label className="text-xs font-medium text-muted-foreground">Mobile</label><input value={form.phone} onChange={set("phone")} data-testid="register-phone" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>
          <div><label className="text-xs font-medium text-muted-foreground">Password</label><PasswordInput value={form.password} onChange={set("password")} required testId="register-password" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>
          {error && <div className="text-sm text-destructive" data-testid="register-error">{error}</div>}
          <button type="submit" disabled={loading} data-testid="register-submit" className="w-full btn-shine bg-navy text-cream font-semibold py-3 rounded-full hover:bg-navy-soft transition-colors disabled:opacity-60">{loading ? "Creating..." : "Create Account"}</button>
        </form>
        <div className="text-center text-sm text-muted-foreground mt-5">Already have an account? <Link to="/login" className="text-navy font-semibold hover:text-gold">Sign in</Link></div>
      </div>
    </div>
  );
}
